namespace GeniuzPOS.Member {
    export class MbReport_01_Dt_Columns {
        static columnsKey = 'Member.MbReport_01_Dt_';
    }
}
